export const themeGet = (path, fallback) => (props) => {
  return path.split('.').reduce((acc, cur) => {
    if (!acc) return fallback;
    return acc[cur] ? acc[cur] : fallback;
  }, props.theme);
};

// Detect language from hostname at runtime
export const getLang = () => {
  if (typeof window === 'undefined') return 'en'; // SSR/build fallback
  const hostname = window.location.hostname;
  // French domains
  if (hostname.includes('solutionsawaken')) return 'fr';
  // Default to English
  return 'en';
};

export const enFr = (en, fr) => {
  return getLang() === 'fr' ? fr : en;
};
